import styled from '@emotion/styled';
import React, { FC, useMemo } from 'react';
import Toggle from '~ComponentsImproved/Toggle';
import { MultiToggleWrapper } from '~ComponentsImproved/Toggle/MultiToggleWrapper';
import Heading from '~ComponentsImproved/Typography/Heading';
import useI18n from '~Translations';
import { useCurrency } from '~Hooks';

const ToggleBlockWrapper = styled.div`
  padding-bottom: 30px;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 4px;

  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    width: 100%;
    height: 40px;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient(to top, rgba(28 35, 44, 1) 0%, rgba(14, 18, 22, 0) 100%);
  }
`;

const ToggleBlockInnerWrapper = styled.div`
  padding-bottom: 30px;
  overflow: auto;
  height: 100%;
`;

interface Props {
  list: any[];
  selectedItems: any[];
  handleToggle: (item: any, isActive: boolean) => void;
}

const SelectRefundArticles: FC<Props> = ({ list, selectedItems, handleToggle }) => {
  const { i18n } = useI18n();
  const currency = useCurrency();

  return (
    <ToggleBlockWrapper>
      <ToggleBlockInnerWrapper>
        <Heading level={3} bottom={24} color="var(--colorWhite)">
          {i18n('Refunds.SelectItems.Title')}
        </Heading>
        <MultiToggleWrapper>
          {list.map((item: any) => (
            <Toggle
              key={item.id}
              label={i18n(item.entry.item.titleLang)}
              description={
                item.price.discount ? (
                  <>
                    <span style={{ textDecoration: 'line-through' }}>
                      {currency.format(item.price.amount)}
                    </span>
                    {' ' + currency.format(item.price.amount - item.price.discount)}
                  </>
                ) : (
                  currency.format(item.price.amount)
                )
              }
              initialValue={selectedItems.some((selectedItem: any) => selectedItem.id === item.id)}
              onToggle={(isActive: boolean) => handleToggle(item, isActive)}
              darkBackground
              fullWidth
            />
          ))}
        </MultiToggleWrapper>
      </ToggleBlockInnerWrapper>
    </ToggleBlockWrapper>
  );
};

export default SelectRefundArticles;
